var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNh30(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1091_5697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8715 2.64941L14.9997 5.09956L10.1279 2.64941L14.9997 11.9087L19.8715 2.64941Z",
    fill: "#FFB71B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6098 9.77421L25.0856 8.32119V3.4209L19.0457 6.0135L15.6838 12.3383C16.9772 12.4874 18.1645 13.1255 19.0025 14.1218C19.8405 15.1181 20.2658 16.3972 20.1911 17.697C20.1165 18.9967 19.5475 20.2187 18.6009 21.1125C17.6543 22.0063 16.4017 22.5042 15.0998 22.5042C13.7979 22.5042 12.5454 22.0063 11.5987 21.1125C10.6521 20.2187 10.0832 18.9967 10.0085 17.697C9.93385 16.3972 10.359 15.1181 11.1971 14.1218C12.0351 13.1255 13.2224 12.4874 14.5157 12.3383L11.1539 6.0135L5.14258 3.4209V8.32119L8.67531 9.77421C7.14315 11.1135 6.05609 12.8883 5.55922 14.8617C5.06235 16.8351 5.17929 18.9131 5.89456 20.8182C6.60983 22.7233 7.88932 24.3649 9.56215 25.5237C11.235 26.6825 13.2215 27.3034 15.2565 27.3034C17.2915 27.3034 19.278 26.6825 20.9509 25.5237C22.6237 24.3649 23.9032 22.7233 24.6184 20.8182C25.3337 18.9131 25.4508 16.8351 24.9539 14.8617C24.457 12.8883 23.3699 11.1135 21.8377 9.77421H21.6098Z",
    fill: "#FFB71B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1091_5697"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 24.7009,
    fill: "white",
    transform: "translate(5 2.64941)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNh30);
export default __webpack_public_path__ + "static/media/NH농협-30.75e86a2fabc0ec43f42b03a7cfd9d7aa.svg";
export { ForwardRef as ReactComponent };